
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dictionary/[[...dictionary]]",
      function () {
        return require("private-next-pages/dictionary/[[...dictionary]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dictionary/[[...dictionary]]"])
      });
    }
  